/**
 * The currencies the app handles (#661), shared by frontend and backend: the
 * fundraising form offers them, and the profile importer accepts an exit amount
 * in one of them and in nothing else.
 *
 * Stored as an ISO 4217 code, never as a symbol: the symbol is display-only,
 * and `Intl.NumberFormat` derives it from the code. No currency table either:
 * ISO 4217 is not a list an admin enriches.
 */
export const CURRENCY_OPTIONS = [
    { value: "USD", label: "USD ($)" },
    { value: "EUR", label: "EUR (€)" },
    { value: "GBP", label: "GBP (£)" },
    { value: "CHF", label: "CHF" },
    { value: "JPY", label: "JPY (¥)" },
    { value: "CAD", label: "CAD (C$)" },
    { value: "AUD", label: "AUD (A$)" },
] as const;

export type CurrencyCode = (typeof CURRENCY_OPTIONS)[number]["value"];

export const CURRENCY_CODES: readonly CurrencyCode[] = CURRENCY_OPTIONS.map((c) => c.value);

export function isCurrencyCode(value: unknown): value is CurrencyCode {
    return typeof value === "string" && (CURRENCY_CODES as readonly string[]).includes(value);
}
